import React, { useEffect } from 'react';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { CardWrapper } from './styled';
import { noop } from 'lodash';

function BarChart({ chartOption, handleBarClick = noop }) {
  const { instance, chartInstanceRefCb } = useChartInstance({});

  useEffect(() => {
    if (instance) {
      instance.setOption(chartOption);
    }
  }, [instance, chartOption]);

  useEffect(() => {
    if (instance) {
      instance.on('click', 'series.bar', (e) => {
        const { data, dataIndex } = e;
        const { value } = data;
        // series is ignored, we only show bad sessions
        handleBarClick({ value: value[0], dataIndex });
      });
    }
    return () => {
      if (instance) {
        instance.off('click');
      }
    };
  }, [instance, handleBarClick]);

  return (
    <CardWrapper>
      <BaseChart chartInstanceRefCb={chartInstanceRefCb} style={{ height: 210, width: '100%' }} />
    </CardWrapper>
  );
}

export default BarChart;
